import * as Actions from '../Actions/EmpresaGrupoProdutoActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    pagina: 1,
    template: null,
    formDialog: {
        type: 'new',
        props: {
            open: false,
            xappRouteParams: '',
            error: null,
            warning: null,
            info: null
        },
        data: null
    },
    error: null

};

const EmpresaGrupoProdutoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAGRUPOPRODUTOS:
            {
                return {
                    ...state,
                    data: action.pagina === 1 ? action.payload : state.data.concat(action.payload),
                    pagina: action.pagina,
                };
            }
        case Actions.GET_EMPRESAGRUPOPRODUTO:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: true

                        },
                        data: action.payload
                    }
                };
            }
        case Actions.OPEN_NEW_EMPRESAGRUPOPRODUTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'new',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_NEW_EMPRESAGRUPOPRODUTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'new',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.OPEN_EDIT_EMPRESAGRUPOPRODUTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams

                        },
                        data: action.data
                    }
                };
            }
        case Actions.CLOSE_EDIT_EMPRESAGRUPOPRODUTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAGRUPOPRODUTO_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    formDialog: {
                        type: 'edit',
                        props:
                        {
                            open: true,
                            error: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAGRUPOPRODUTO_INFO:
            {
                return {
                    ...state,
                    success: true,
                    formDialog: {
                        type: 'edit',
                        props:
                        {
                            open: true,
                            info: action.payload,
                            id: action.id
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAGRUPOPRODUTO_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    formDialog: {
                        props:
                        {
                            open: false,
                            warning: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAGRUPOPRODUTO_SELECIONAR_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    error: action.payload,
                };
            }
        case Actions.EMPRESAGRUPOPRODUTO_SELECIONAR_INFO:
            {
                return {
                    ...state,
                    success: true,
                    formDialog: {
                        type: 'edit',
                        props:
                        {
                            open: false,
                            info: action.payload,
                            id: action.id
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAGRUPOPRODUTO_SELECIONAR_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    formDialog: {
                        props:
                        {
                            open: false,
                            warning: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.GET_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaGrupoProdutoReducer;
export default reducer;
